export default __webpack_public_path__ + "images/0222e5b295a5f9d4f71d6ddb3e61200c-aov-hover-bold.svg";